import { jsx as _jsx } from "tsx-dom/jsx-runtime";
/**
 * @returns The HTMLElement containing the CSS styles that change dynamically
 */
export function DynamicStyles() {
    return _jsx("style", { id: "dynamic-styles" });
}
